/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime'
import type {
  ActivePromoCode200Response,
  ActivePromoCode400Response,
  ActivePromoCode422Response,
  ActivePromoCodeRequest,
  CheckPaymentStatusAsOrder200Response,
  CheckPromoCode400Response,
  CreatePromoCode200Response,
  CreatePromoCode400Response,
  CreatePromoCode422Response,
  CreatePromoCodeRequest,
  DeleteActivePromoCode400Response,
  GetActivePromoCode200Response,
  GetActivePromoCode400Response,
  GetAddressSuggest401Response,
  GetAddressSuggest403Response,
} from '../models/index'
import {
  ActivePromoCode200ResponseFromJSON,
  ActivePromoCode200ResponseToJSON,
  ActivePromoCode400ResponseFromJSON,
  ActivePromoCode400ResponseToJSON,
  ActivePromoCode422ResponseFromJSON,
  ActivePromoCode422ResponseToJSON,
  ActivePromoCodeRequestFromJSON,
  ActivePromoCodeRequestToJSON,
  CheckPaymentStatusAsOrder200ResponseFromJSON,
  CheckPaymentStatusAsOrder200ResponseToJSON,
  CheckPromoCode400ResponseFromJSON,
  CheckPromoCode400ResponseToJSON,
  CreatePromoCode200ResponseFromJSON,
  CreatePromoCode200ResponseToJSON,
  CreatePromoCode400ResponseFromJSON,
  CreatePromoCode400ResponseToJSON,
  CreatePromoCode422ResponseFromJSON,
  CreatePromoCode422ResponseToJSON,
  CreatePromoCodeRequestFromJSON,
  CreatePromoCodeRequestToJSON,
  DeleteActivePromoCode400ResponseFromJSON,
  DeleteActivePromoCode400ResponseToJSON,
  GetActivePromoCode200ResponseFromJSON,
  GetActivePromoCode200ResponseToJSON,
  GetActivePromoCode400ResponseFromJSON,
  GetActivePromoCode400ResponseToJSON,
  GetAddressSuggest401ResponseFromJSON,
  GetAddressSuggest401ResponseToJSON,
  GetAddressSuggest403ResponseFromJSON,
  GetAddressSuggest403ResponseToJSON,
} from '../models/index'

export interface ActivePromoCodeOperationRequest {
  activePromoCodeRequest: ActivePromoCodeRequest
}

export interface CheckPromoCodeRequest {
  promocode: string
}

export interface CreatePromoCodeOperationRequest {
  createPromoCodeRequest: CreatePromoCodeRequest
}

/**
 * PromoCodesApi - interface
 *
 * @export
 * @interface PromoCodesApiInterface
 */
export interface PromoCodesApiInterface {
  /**
   * Активирует промокод для текущего пользователя (заменяет ранее активированный). Промокод должен быть действительным, не использованным и не зарезервированным пользователем, с активной акцией. Требуется подтверждённый email.
   * @summary Активировать промокод пользователя
   * @param {ActivePromoCodeRequest} activePromoCodeRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PromoCodesApiInterface
   */
  activePromoCodeRaw(
    requestParameters: ActivePromoCodeOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ActivePromoCode200Response>>

  /**
   * Активирует промокод для текущего пользователя (заменяет ранее активированный). Промокод должен быть действительным, не использованным и не зарезервированным пользователем, с активной акцией. Требуется подтверждённый email.
   * Активировать промокод пользователя
   */
  activePromoCode(
    requestParameters: ActivePromoCodeOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ActivePromoCode200Response>

  /**
   * Проверка промокода: активен, находится в периоде действия и остались использования. Требуется подтверждённый email.
   * @summary Проверить промокод
   * @param {string} promocode Код промокода
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PromoCodesApiInterface
   */
  checkPromoCodeRaw(
    requestParameters: CheckPromoCodeRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CheckPaymentStatusAsOrder200Response>>

  /**
   * Проверка промокода: активен, находится в периоде действия и остались использования. Требуется подтверждённый email.
   * Проверить промокод
   */
  checkPromoCode(
    requestParameters: CheckPromoCodeRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CheckPaymentStatusAsOrder200Response>

  /**
   * Создание промокода на период действия. Дата окончания должна быть позже даты начала и текущего момента. Требуется подтверждённый email.
   * @summary Создать промокод
   * @param {CreatePromoCodeRequest} createPromoCodeRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PromoCodesApiInterface
   */
  createPromoCodeRaw(
    requestParameters: CreatePromoCodeOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CreatePromoCode200Response>>

  /**
   * Создание промокода на период действия. Дата окончания должна быть позже даты начала и текущего момента. Требуется подтверждённый email.
   * Создать промокод
   */
  createPromoCode(
    requestParameters: CreatePromoCodeOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CreatePromoCode200Response>

  /**
   * Удаляет активированный промокод текущего пользователя. Требуется подтверждённый email.
   * @summary Удалить активный промокод пользователя
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PromoCodesApiInterface
   */
  deleteActivePromoCodeRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CheckPaymentStatusAsOrder200Response>>

  /**
   * Удаляет активированный промокод текущего пользователя. Требуется подтверждённый email.
   * Удалить активный промокод пользователя
   */
  deleteActivePromoCode(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CheckPaymentStatusAsOrder200Response>

  /**
   * Активированный промокод текущего пользователя; data = null, если промокод не активирован. Требуется подтверждённый email.
   * @summary Получить активный промокод пользователя
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PromoCodesApiInterface
   */
  getActivePromoCodeRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetActivePromoCode200Response>>

  /**
   * Активированный промокод текущего пользователя; data = null, если промокод не активирован. Требуется подтверждённый email.
   * Получить активный промокод пользователя
   */
  getActivePromoCode(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetActivePromoCode200Response>
}

/**
 *
 */
export class PromoCodesApi
  extends runtime.BaseAPI
  implements PromoCodesApiInterface
{
  /**
   * Активирует промокод для текущего пользователя (заменяет ранее активированный). Промокод должен быть действительным, не использованным и не зарезервированным пользователем, с активной акцией. Требуется подтверждённый email.
   * Активировать промокод пользователя
   */
  async activePromoCodeRaw(
    requestParameters: ActivePromoCodeOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ActivePromoCode200Response>> {
    if (requestParameters['activePromoCodeRequest'] == null) {
      throw new runtime.RequiredError(
        'activePromoCodeRequest',
        'Required parameter "activePromoCodeRequest" was null or undefined when calling activePromoCode().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/v1/promo-codes/set-user-active-promo-code`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: ActivePromoCodeRequestToJSON(
          requestParameters['activePromoCodeRequest']
        ),
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ActivePromoCode200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Активирует промокод для текущего пользователя (заменяет ранее активированный). Промокод должен быть действительным, не использованным и не зарезервированным пользователем, с активной акцией. Требуется подтверждённый email.
   * Активировать промокод пользователя
   */
  async activePromoCode(
    requestParameters: ActivePromoCodeOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ActivePromoCode200Response> {
    const response = await this.activePromoCodeRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }

  /**
   * Проверка промокода: активен, находится в периоде действия и остались использования. Требуется подтверждённый email.
   * Проверить промокод
   */
  async checkPromoCodeRaw(
    requestParameters: CheckPromoCodeRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CheckPaymentStatusAsOrder200Response>> {
    if (requestParameters['promocode'] == null) {
      throw new runtime.RequiredError(
        'promocode',
        'Required parameter "promocode" was null or undefined when calling checkPromoCode().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/v1/promo-codes/check/{promocode}`.replace(
          `{${'promocode'}}`,
          encodeURIComponent(String(requestParameters['promocode']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CheckPaymentStatusAsOrder200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Проверка промокода: активен, находится в периоде действия и остались использования. Требуется подтверждённый email.
   * Проверить промокод
   */
  async checkPromoCode(
    requestParameters: CheckPromoCodeRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CheckPaymentStatusAsOrder200Response> {
    const response = await this.checkPromoCodeRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }

  /**
   * Создание промокода на период действия. Дата окончания должна быть позже даты начала и текущего момента. Требуется подтверждённый email.
   * Создать промокод
   */
  async createPromoCodeRaw(
    requestParameters: CreatePromoCodeOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CreatePromoCode200Response>> {
    if (requestParameters['createPromoCodeRequest'] == null) {
      throw new runtime.RequiredError(
        'createPromoCodeRequest',
        'Required parameter "createPromoCodeRequest" was null or undefined when calling createPromoCode().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/v1/promo-codes/create`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: CreatePromoCodeRequestToJSON(
          requestParameters['createPromoCodeRequest']
        ),
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CreatePromoCode200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Создание промокода на период действия. Дата окончания должна быть позже даты начала и текущего момента. Требуется подтверждённый email.
   * Создать промокод
   */
  async createPromoCode(
    requestParameters: CreatePromoCodeOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CreatePromoCode200Response> {
    const response = await this.createPromoCodeRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }

  /**
   * Удаляет активированный промокод текущего пользователя. Требуется подтверждённый email.
   * Удалить активный промокод пользователя
   */
  async deleteActivePromoCodeRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CheckPaymentStatusAsOrder200Response>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/v1/promo-codes/delete-user-active-promo-code`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CheckPaymentStatusAsOrder200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Удаляет активированный промокод текущего пользователя. Требуется подтверждённый email.
   * Удалить активный промокод пользователя
   */
  async deleteActivePromoCode(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CheckPaymentStatusAsOrder200Response> {
    const response = await this.deleteActivePromoCodeRaw(initOverrides)
    return await response.value()
  }

  /**
   * Активированный промокод текущего пользователя; data = null, если промокод не активирован. Требуется подтверждённый email.
   * Получить активный промокод пользователя
   */
  async getActivePromoCodeRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetActivePromoCode200Response>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/v1/promo-codes/get-user-active-promo-code`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GetActivePromoCode200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Активированный промокод текущего пользователя; data = null, если промокод не активирован. Требуется подтверждённый email.
   * Получить активный промокод пользователя
   */
  async getActivePromoCode(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetActivePromoCode200Response> {
    const response = await this.getActivePromoCodeRaw(initOverrides)
    return await response.value()
  }
}
